module.exports = __webpack_public_path__ + "static/media/ARIAL.fa3228aa.TTF";